<form (ngSubmit)="submitComms(formGroup.value)" autocomplete="off" novalidate>
  <div class="sms" [formGroup]="formGroup">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <small>*Only users with ontrack accounts are visible here</small>
          <mat-form-field appearance="outline">
            <mat-label>Users</mat-label>
            <mat-select formControlName="parties" multiple>
              <mat-option *ngFor="let login of loginList" [value]="login">[{{login.username}}] {{login.name}}</mat-option>
            </mat-select>
            <mat-error>Please select one</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Subject</mat-label>
            <input matInput placeholder="Subject" formControlName="subject">
            <mat-error>Please enter a subject</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Message</mat-label>
            <textarea matInput placeholder="Message" rows="5" formControlName="message"></textarea>
            <mat-error *ngIf="formGroup.get('message').hasError('required')">
              Please provide a message
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row pt-2 pb-2">
        <div class="col-sm-6">
        </div>
        <div class="col-sm-6 text-end">
          <button mat-raised-button type="submit" color="primary">Submit</button>
        </div>
      </div>
    </div>
  </div>
</form>
